import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const ConfirmCancellationModal = (props) => {
    return (
        <ModalComponent onCloseIconClick={() => props.toggleModal(false)}>
            <HeaderPanel title={props.title} />
            <Panel negativeMargin isDefaultCursor>
                <PanelRow>
                    <IconWrapper>
                        <Icon name="cross" color="error" size="24px" />
                    </IconWrapper>
                    <Text>{props.text}</Text>
                </PanelRow>
            </Panel>
            <FixedBottomPanel isRightAligned>
                <Button
                    type="button"
                    raised={true}
                    caption={props.continueButton}
                    onClick={() => {
                        props.openCancelPopup();
                    }}
                />
            </FixedBottomPanel>
        </ModalComponent>
    );
};
ConfirmCancellationModal.propTypes = {
    openCancelPopup: PropTypes.func,
    title: PropTypes.string,
    text: PropTypes.string,
    continueButton: PropTypes.string,
};

export default connect(null, { toggleModal })(ConfirmCancellationModal);
